import { SCHEDULE_COLUMNS, WEEKLY_SCHEDULE } from '../../data/schedule';

const ScheduleSection = () => (
  <section id="horarios" className="bg-white py-32">
    <div className="container mx-auto px-6">
      <div className="mx-auto mb-20 max-w-2xl text-center">
        <h2 className="mb-4 text-[10px] font-bold uppercase tracking-[0.5em] text-slate-400">
          Agenda Las Palmas
        </h2>
        <h3 className="mb-6 text-5xl font-black tracking-tight text-slate-900">
          Tu Espacio de Crecimiento
        </h3>
        <p className="text-xs font-bold uppercase tracking-widest text-slate-500">
          Lunes a Viernes: 9:00 - 20:00
        </p>
      </div>

      <div
        className="notranslate mx-auto max-w-5xl overflow-x-auto rounded-[3rem] border border-slate-100 bg-slate-50 p-4 shadow-sm"
        translate="no"
      >
        <table className="w-full border-separate border-spacing-y-2 text-left">
          <thead>
            <tr>
              <th className="px-8 py-4 text-[10px] font-black uppercase tracking-widest text-slate-400">
                Actividad
              </th>
              {SCHEDULE_COLUMNS.map((day) => (
                <th
                  key={day}
                  className="px-4 py-4 text-[10px] font-black uppercase tracking-widest text-slate-400"
                >
                  {day}
                </th>
              ))}
            </tr>
          </thead>
          <tbody className="space-y-4">
            {WEEKLY_SCHEDULE.map((row, i) => (
              <tr
                key={i}
                className="group rounded-2xl bg-white transition-all duration-300 hover:bg-slate-900 hover:text-white"
              >
                <td className="rounded-l-2xl border-l-4 border-emerald-500 px-8 py-6 text-sm font-black uppercase tracking-widest">
                  {row.activity}
                </td>
                {row.singleCell ? (
                  <td className="rounded-r-2xl px-4 py-6 text-center text-xs font-bold" colSpan={SCHEDULE_COLUMNS.length}>
                    {row.singleCell}
                  </td>
                ) : (
                  SCHEDULE_COLUMNS.map((day, index) => (
                    <td
                      key={`${row.activity}-${day}`}
                      className={`px-4 py-6 text-xs font-bold ${
                        index === SCHEDULE_COLUMNS.length - 1 ? 'rounded-r-2xl' : ''
                      }`}
                    >
                      <div className="grid min-h-[56px] grid-rows-2 gap-1">
                        <span>{row.morning[day]}</span>
                        <span>{row.afternoon[day]}</span>
                      </div>
                    </td>
                  ))
                )}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  </section>
);

export default ScheduleSection;
